<div class="main-div">
    <!-- <div class="success-section">
        <div class="success-image inline-success">
            <img src="assets/img/success_picture.png" alt="success" class="success-img">
        </div>
        <div class="success-messages inline-success">
            <p class="success-message">{{confirmAccounts.successMessage}}</p>
            <p class="success-description"><b>{{confirmAccounts.successDescription}}</b></p>
        </div>
     <p class="success-description">{{confirmAccounts.successDescription}}</p>
      </div>
    <div class="confirm-section">
        <div class="greybox">
            <p class="noteheading">{{confirmAccounts.next}}</p>
            <p class="notetext" *ngIf="!abm">{{confirmAccounts.note}}</p>
            <p class="notetext" *ngIf="abm">{{confirmAccounts.noteabm}}</p>
            <div class="content-wrapper">
                <div class="ng-modal-number-container">
                   <div class="numberContainer">
                        <div class="numberIcon">{{confirmAccounts.numberIcon1}}</div>
                        <div class="text1"> {{confirmAccounts.content1}}</div>
                   </div>
                   <div class="numberContainer">
                        <div class="numberIcon">{{confirmAccounts.numberIcon2}}</div>
                        <div class="text2" *ngIf="isABMFE"> {{confirmAccounts.abmFecontent2}}</div>
                        <div class="text2" *ngIf="abm && !isABMFE"> {{confirmAccounts.abmcontent2}}</div>
                        <div class="text2" *ngIf="ztp"> {{confirmAccounts.ztpcontent2}}</div>
                        <div class="text2" *ngIf="kme"> {{confirmAccounts.kmecontent2}}</div>
                   </div>
                   <div class="numberContainer">
                        <div class="numberIcon">{{confirmAccounts.numberIcon3}}</div>
                        <div class="text3" *ngIf="isABMFE"> {{confirmAccounts.abmFecontent3}}</div>
                        <div class="text3" *ngIf="abm && !isABMFE"> {{confirmAccounts.abmcontent3}}</div>
                        <div class="text3" *ngIf="ztp"> {{confirmAccounts.ztpcontent3}}</div>
                        <div class="text3" *ngIf="kme"> {{confirmAccounts.kmecontent3}}</div>
                   </div>
                   <div class="numberContainer">
                        <div class="numberIcon">{{confirmAccounts.numberIcon4}}</div>
                        <div class="text4"> {{confirmAccounts.content4}}</div>
                   </div>
                </div>
                <div class="content-text">
                    <div class="text-box">
                        <div class="text1"> {{confirmAccounts.content1}}</div>
                        <div class="text2" *ngIf="isABMFE"> {{confirmAccounts.abmFecontent2}}</div>
                        <div class="text2" *ngIf="abm && !isABMFE"> {{confirmAccounts.abmcontent2}}</div>
                        <div class="text2" *ngIf="ztp"> {{confirmAccounts.ztpcontent2}}</div>
                        <div class="text2" *ngIf="kme"> {{confirmAccounts.kmecontent2}}</div>
                        <div class="text3" *ngIf="isABMFE"> {{confirmAccounts.abmFecontent3}}</div>
                        <div class="text3" *ngIf="abm && !isABMFE"> {{confirmAccounts.abmcontent3}}</div>
                        <div class="text3" *ngIf="ztp"> {{confirmAccounts.ztpcontent3}}</div>
                        <div class="text3" *ngIf="kme"> {{confirmAccounts.kmecontent3}}</div>
                        <div class="text4"> {{confirmAccounts.content4}}</div>
                        
                    </div>
                    
                </div>
            </div>
        </div>
        <p class="confirm-heading">{{confirmAccounts.enrollmentDetailsHeading}}</p> <br>
        <p class="confirm-subheading">{{confirmAccounts.enrollmentDetailsSubheading}}</p>
        <br>
        <div class="confirm-info">
            <div class="first-block confirm-blocks">
                <p class="confirm-block-heading">{{confirmAccounts.fanLabel}}</p>
                <p class="confirm-block-value" *ngFor="let fan of signedupData">{{fan.fanId}}</p>
            </div>
            <div class="second-block confirm-blocks" *ngIf="ztp">
                <p class="confirm-block-heading">{{confirmAccounts.productId1}}</p>
                <p class="confirm-block-value" *ngFor="let fan of signedupData">{{enrolledData.emmAccountId}}</p>
            </div>
            <div class="second-block confirm-blocks" *ngIf="abm">
                <p class="confirm-block-heading">{{confirmAccounts.productId2}}</p>
                <p class="confirm-block-value" *ngFor="let fan of signedupData">{{enrolledData.emmAccountId}}</p>
            </div>
            <div class="second-block confirm-blocks" *ngIf="kme">
                <p class="confirm-block-heading">{{confirmAccounts.productId3}}</p>
                <p class="confirm-block-value" *ngFor="let fan of signedupData">{{enrolledData.emmAccountId}}</p>
            </div>
            <div class="third-block confirm-blocks">
                <p class="confirm-block-heading">{{confirmAccounts.existingDevicesLabel}}</p>
                <p class="confirm-block-value" *ngFor="let fan of signedupData">{{fan.status}}</p>
            </div>
        </div>
        <br>
    </div>
    <br>
    <hr>
    <div class="prod-section">
        <p class="prod-heading"><b>{{confirmAccounts.prodTypeHeading}}</b></p>
        <p class="prod-file-name"><b>{{confirmAccounts.prodType}}</b> {{prodcode}}</p>
    </div>
    <br>
    <hr>
    <div class="submit-section">
        <button class="btn btn-secondary" id="gotoApple"(click)="gotoProdSel()" *ngIf="abm && availableFansFlag">{{confirmAccounts.gotoProdSel}}</button>
        <button class="btn btn-secondary" id="requestEnrollment" (click)="gotoDashboard()">{{confirmAccounts.returnToDashboard}}</button>
    </div>
     
     <ng-container *ngIf="abm && availableFansFlag; then submitSection01; else submitSection"></ng-container>
     <ng-template #submitSection01>
         <div class="submit-section01">
             <button class="btn btn-secondary" id="gotoApple"(click)="gotoProdSel()">{{confirmAccounts.gotoProdSel}}</button>
             <button class="btn btn-secondary requestEnrollment" id="requestEnrollment" (click)="gotoDashboard()">{{confirmAccounts.returnToDashboard}}</button>
         </div><br>
     </ng-template>
     <ng-template #submitSection>
         <div class="submit-section">
             <button class="btn btn-secondary" id="requestEnrollment" (click)="gotoDashboard()">{{confirmAccounts.returnToDashboard}}</button>
         </div><br>
     </ng-template>

    
    <div class="Accessories-section" *ngIf="isPremier">  
        <h2>Need something else?</h2>
        <h5>Shop our expansive selection of accessories</h5>
        <div class="imageContanier">
            <figure class="link-figure">
                <img src="assets\img\cases-accessories.png" alt="image icon for Accesories Icon" />
            </figure> 
            <figure class="link-figure">
                <img src="assets\img\Chargers-accessories.png" alt="image icon for Accesories Icon" />
            </figure> 
            <figure class="link-figure">
                <img src="assets\img\headphones-accessories.png" alt="image icon for Accesories Icon" />
            </figure> 
            <figure class="link-figure">
                <img src="assets\img\ScreenProtector-accessories.png" alt="image icon for Accesories Icon" />
            </figure> 
            <figure class="link-figure">
                <img src="assets\img\internet-accessories.png" alt="image icon for Accesories Icon" />
            </figure> 
            <figure class="link-figure">
                <img src="assets\img\Speakers-accessories.png" alt="image icon for Accesories Icon" />
            </figure> 
            <figure class="link-figure">
                <img src="assets\img\Popsocket-accessories.png" alt="image icon for Accesories Icon" />
            </figure> 
            <figure class="link-figure">
                <img src="assets\img\Gaming-accessories.png" alt="image icon for Accesories Icon" />
            </figure>
        </div>
        <button class="btn btn-secondary" id="AccesoriesPage" (click)="gotoAccesories()" *ngIf="isPremier">Purchase Accessories</button>
    </div> -->

    <!-- New confirmation design -->
     <div class="success-section">
        <div>
            <img src="assets/img/confirm_icon1.png" alt="success" class="success-img">
        </div>
        <p class="reg-heading">Registration Submitted!</p>
        <br/>
        <p>A confirmation will be sent to the contact details associated with your account.</p>
    </div>
     <div class="expect-section col-md-12 col-ms-12">
        <div class="left-section col-12 col-md-5 col-sm-12">
            <h2><strong>What to expect:</strong></h2>
            <p>Meanwhile, you can...</p>
            <ul>
                <li><a href="javascript:void(0);" (click)="naviateToPage('manageInventory')">Manage your devices > </a></li>
                <li><a href="javascript:void(0);" (click)="naviateToPage('productselection')">Register another program > </a></li>
                <li><a href="javascript:void(0);" (click)="naviateToPage('home')">Go back to homepage > </a></li>
            </ul>

        </div>
        <div class="right-section col-12 col-md-7 col-sm-12">
            <ul>
                <li>
                    <div class="info-section">
                        <div class="left-icon"><img src="assets/img/confirm_icon4.png" alt="Existing device information" class="round-img"></div>
                        <div class="right-info"><strong>Existing device information</strong> will begin populating in the platform.</div>
                    </div>
                </li>
                <li>
                    <div class="info-section">
                        <div class="left-icon"><img src="assets/img/confirm_icon3.png" alt="Existing device information" class="round-img"></div>
                        <div class="right-info"><strong>Enrollment requests</strong> for existing devices will be processed, if applicable.</div>
                    </div>
                </li>
                <li>
                    <div class="info-section">
                        <div class="left-icon"><img src="assets/img/confirm_icon2.png" alt="Existing device information" class="round-img"></div>
                        <div class="right-info"><strong>New eligible devices</strong> will auto-enroll in your third-party device enrollment program.</div>
                    </div>
                </li>
            </ul>
        </div>
     </div>
     <div class="learnmore-section">
        <div class="image-content">
            <span>NEW! AT&T Business Protect<sup style="font-size: 10px;">SM</sup></span>
            <h4><strong>Get protected from the unexpected</strong></h4>
            <p>With AT&T Business Protect, you can keep your devices protected from mechanical breakdown, drops, broken screens, and other damage</p>
            <a href="https://www.business.att.com/products/business-protect.html" target="_blank" class="btn btn-secondary continue-btn" id="learnMore">Learn More</a>
        </div>
        <img src="assets/img/registration_confirmation_bg.png" alt="Learn more" class="learnmore-img">
     </div>
</div>
